import { Component, ViewChild} from '@angular/core';
import { PivotBasePop } from '../../pivot/renderers/settings/pivot-base.pop';
import { WizDatasource, WizEventManager, WizList, WizPopUp } from '@wizeoo/akm-component-lib';
import { MultiDisplayConfig } from '../../../multi-display/config/multi-display.config';
import { VisionStepVO } from '../../../../vo/vision/visionstep.vo';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { KeyPair } from '@wizeoo/akm-compute-lib';
import { GeneratorRestrictionPop, GeneratorRestrictionPopData } from './generator-restriction.pop';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { GeneratorRestrictionRenderer } from './generator-restriction.renderer';
import { WidgetKeyPair } from '@wizeoo/akm-message-lib';
import { ViewData } from '../../../../model/view.data';

@Component({
  selector: 'generator-settings-pop',
  templateUrl: 'generator-settings.pop.html',
})
export class GeneratorSettingsPop extends PivotBasePop {
  
  @ViewChild('restrictionList', { read: WizList }) restrictionList: WizList; // liste des tables de travail
  
  show(): void {
    super.show();
    WizEventManager.addListener(this, this.restrictionList, ALK_EVENT_TYPE.DELETE, this.deleteRestrict);
    WizEventManager.addListener(this, this.restrictionList, ALK_EVENT_TYPE.EDIT, this.editRestrict);
  }

  public onHide(): void {
    super.onHide();
    WizEventManager.removeListener(this, this.restrictionList, ALK_EVENT_TYPE.DELETE);
    WizEventManager.removeListener(this, this.restrictionList, ALK_EVENT_TYPE.EDIT);
 
  }




  /** Data source des objets de construction */
  public stepDS: WizDatasource<VisionStepVO> = new WizDatasource<VisionStepVO>([])
    .setSortFields([{ property: 'level', way: 'asc' }])
    .setSelectionMode('multiple')
    .build();

    /**
   * configuration de la liste de steps
   */
    public stepConfig: MultiDisplayConfig<VisionStepVO> = {
      model: this.model,
      datasource: this.stepDS,
      defaultMode: 'grid',
      grid: {
        rowSelection: 'multiple',
        enabled: true,
        columns: [
          { headerName: '$.common.label.$', field: 'levelAndLabel', flex: 1 },

        ],
        suppressRowClickSelection: true,
      },
    };
  
  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();
      // alimentation de la liste des steps
      if (!!this.model?.currentVision?.visionSteps) {
      this.stepDS.setSource(Object.values(this.model.currentVision.visionSteps).map(vs => new VisionStepVO(vs)));
      
      let selected: VisionStepVO[] = [];
      let stepSet: Set<string> = new Set(this.context.ct?.split(ViewData.FILTER_ELEMENT_SEPARATOR) || []);
      this.stepDS.getSource().forEach(vsvo => {
        if(stepSet.has(vsvo.level.toString())) {
          selected.push(vsvo);
        }
      });
      this.stepDS.select(selected);
    } else {
      this.stepDS.setSource([]);
    }

    let keys: KeyPair[] = [];
    this.context.cp.forEach(wkp => {
      keys.push({r: wkp.cod, l: wkp.val.toString(), s: null});
    });

    this.restrictionDS.setSource(keys);
  }


  /** Data source des objets de construction */
  public restrictionDS: WizDatasource<KeyPair> = new WizDatasource<KeyPair>([])
    .setItemCodeField('r')  
    .setSortFields([{ property: 'r', way: 'asc' }])
    .setSelectionMode('multiple')
    .build();

    /**
   * configuration de la liste de steps
   */
    public restrictionConfig: MultiDisplayConfig<KeyPair> = {
      model: this.model,
      datasource: this.restrictionDS,
      defaultMode: 'grid',
      grid: {
        rowSelection: 'multiple',
        enabled: true,
        columns: [
          { headerName: '$.common.code.$', field: 'r', flex: 1 },
          { headerName: '$.common.label.$', field: 'l', flex: 1 },

        ],
        suppressRowClickSelection: true,
      },
    };


    public doAct(who: string): void {
      // console.log('doAct query', who);
      this.editRestrict();
    }


    public editRestrict(e: AlkEvent = null): void {
      let key: KeyPair = null
      // si flow est null, c'est un create
      if(!e) {
        key =  {r: null, s: null, l: null};
      } else {
        key = e.data;
      }
      
      let datas: GeneratorRestrictionPopData = {key, callback: this.backFromRestrictPop.bind(this)};
  
  
      // construction unique de l'instance
      let pop = new WizPopUp(GeneratorRestrictionPop, false, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER, GeneratorRestrictionPop.width, GeneratorRestrictionPop.height, datas);
      pop.show();
    }
  
    /** demande d'édition de la table */
    public deleteRestrict(e: AlkEvent = null): void {
      // console.log('deleteTable', e);
  
      this.restrictionDS.getSource().forEach(wto => {
        if(wto.r === e.data.r ) {
          this.restrictionDS.removeItem(wto);
        }
      });
  
      this.feedRestrict();
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    }

    public backFromRestrictPop(datas: GeneratorRestrictionPopData): void {
  
      // modif de schéma ou de nom
      // on delete l'ancien (si existe) et on crée
      // en fait, on le fait tout le temps, c'est plus simple
      this.restrictionDS.getSource().forEach(wto => {
        if(wto.r === datas.key.r ) {
          this.restrictionDS.removeItem(wto);
        }
      });
      
      this.restrictionDS.addItem(datas.update);
  
      this.feedRestrict();
      // console.log("process flows", this.processClone.flows);
  
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    }
  
    /**
     * synchronisation des flows sur le clone depuis la collection
     */
    private feedRestrict(): void {
  
    }

  
  public restrictionRenderer: any = GeneratorRestrictionRenderer; 
  
  /** 
   * modification du context pour retour sur la base des params
   * @override
   */
  public updateContext(): void {
    super.updateContext();
    this.context.cp = [];
    this.restrictionDS.getSource().forEach(k => {
      let cp: WidgetKeyPair = {cod: k.r, val: k.l};
      this.context.cp.push(cp);
    });

    this.context.ct = this.stepDS.selectedItems.map(item => item.level).join(ViewData.FILTER_ELEMENT_SEPARATOR); 

  }

}
